// Restricts input for each element in the set of matched elements to the given inputFilter
// https://stackoverflow.com/questions/995183/how-to-allow-only-numeric-0-9-in-html-inputbox-using-jquery
$.fn.inputFilter = function(inputFilter) {
    return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function() {
        if (inputFilter(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        } else if (this.hasOwnProperty("oldValue")) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
    });
};

function customSteps() {

    let $input = $('.custom-steps__input', this),
        $buttonDecrease = $('.custom-steps__control--decrease', this),
        $buttonIncrease = $('.custom-steps__control--increase', this),
        minVal = parseInt($(this).data('min')),
        maxVal = parseInt($(this).data('max')),
        stepSize = parseInt($(this).data('step'));

    // Restrict input to digits by using a regular expression filter.
    $input.inputFilter(function(value) {
        return /^\d*$/.test(value);
    });

    function decreaseAction() {
        let currentVal = parseInt($input.val());

        if (currentVal > minVal) {
            $input.val(currentVal - stepSize).trigger('change');
        }

        if ($buttonIncrease.is(':disabled')) {
            $buttonIncrease.prop({disabled: false});
        }

        checkInput();
    }

    function increaseAction() {
        let currentVal = parseInt($input.val());

        if (currentVal < maxVal) {
            $input.val(currentVal + stepSize).trigger('change');
        }

        if ($buttonDecrease.is(':disabled')) {
            $buttonDecrease.prop({disabled: false});
        }

        checkInput();
    }

    function checkInput() {
        let currentVal = parseInt($input.val());

        // if current value is higher than max or lower than min, correct value
        if (currentVal > maxVal) {
            currentVal = maxVal;
            $input.val(maxVal);
        } else if (currentVal < minVal) {
            currentVal = minVal;
            $input.val(minVal);
        }

        // if min or max value is reached, disable corresponding button
        $buttonDecrease.prop({disabled: false});
        $buttonIncrease.prop({disabled: false});

        if (currentVal === minVal) {
            $buttonDecrease.prop({disabled: true});
        } else if (currentVal === maxVal) {
            $buttonIncrease.prop({disabled: true});
        }
    }

    $input.on('change keyup', checkInput);

    $buttonDecrease.on('click', decreaseAction);
    $buttonIncrease.on('click', increaseAction);

    // check input on pageload
    checkInput();
}

$('.custom-steps').each(customSteps);
